export {
    OwaUserConfigurationProxy as UserConfigurationProxy,
    getConfiguration,
    getConfigurationSync,
    setConfiguration,
    updateConfiguration,
} from './cache';
export { default as isDefaultMailbox } from './utils/isDefaultMailbox';
export { default as getDefaultLogonEmailAddress } from './utils/getDefaultLogonEmailAddress';
